/**
 * Estimated Delivery Date Calculator
 * 
 * Rules:
 * - IT: Standard products ship Mon-Fri, Plants ship Mon-Wed, deliver in 1-3 business days
 * - IT: "Su ordinazione" products: 10 business days
 * - EU (FR/EN): All products ship Monday only, deliver in 4-5 business days
 * - Deadline: 12:00 CET - orders before 12:00 on a shipping day ship same day
 * - Italian public holidays are excluded from business days
 */
(function () {
  'use strict';

  var WEEKDAYS_IT = ['Domenica', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato'];
  var MONTHS_IT = ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'];
  var MONTHS_SHORT_IT = ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'];

  var WEEKDAYS_FR = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'];
  var MONTHS_FR = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];
  var MONTHS_SHORT_FR = ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Aoû', 'Sep', 'Oct', 'Nov', 'Déc'];

  var WEEKDAYS_EN = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var MONTHS_EN = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var MONTHS_SHORT_EN = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  // Easter calculation (Anonymous Gregorian algorithm)
  function getEasterDate(year) {
    var a = year % 19;
    var b = Math.floor(year / 100);
    var c = year % 100;
    var d = Math.floor(b / 4);
    var e = b % 4;
    var f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3);
    var h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4);
    var k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var month = Math.floor((h + l - 7 * m + 114) / 31);
    var day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(year, month - 1, day);
  }

  // Build set of Italian public holidays for a given year
  function getItalianHolidays(year) {
    var holidays = {};
    var fixed = [
      [0, 1],   // Capodanno
      [0, 6],   // Epifania
      [3, 25],  // Liberazione
      [4, 1],   // Festa dei lavoratori
      [5, 2],   // Festa della Repubblica
      [7, 15],  // Ferragosto
      [10, 1],  // Ognissanti
      [11, 8],  // Immacolata
      [11, 25], // Natale
      [11, 26]  // Santo Stefano
    ];

    for (var i = 0; i < fixed.length; i++) {
      var d = new Date(year, fixed[i][0], fixed[i][1]);
      holidays[dateKey(d)] = true;
    }

    // Easter and Easter Monday
    var easter = getEasterDate(year);
    holidays[dateKey(easter)] = true;
    var easterMonday = new Date(easter);
    easterMonday.setDate(easterMonday.getDate() + 1);
    holidays[dateKey(easterMonday)] = true;

    return holidays;
  }

  function dateKey(d) {
    return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
  }

  // Cache holidays per year
  var holidayCache = {};
  function isItalianHoliday(d) {
    var y = d.getFullYear();
    if (!holidayCache[y]) {
      holidayCache[y] = getItalianHolidays(y);
    }
    return !!holidayCache[y][dateKey(d)];
  }

  function isWeekday(d) {
    var day = d.getDay();
    return day >= 1 && day <= 5;
  }

  function isBusinessDay(d) {
    return isWeekday(d) && !isItalianHoliday(d);
  }

  // Check if a date is a valid shipping day
  // shippingDays: array of day numbers (0=Sun, 1=Mon, ..., 6=Sat)
  function isShippingDay(d, shippingDays) {
    return shippingDays.indexOf(d.getDay()) !== -1 && !isItalianHoliday(d);
  }

  function cloneDate(d) {
    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
  }

  function addDays(d, n) {
    var r = cloneDate(d);
    r.setDate(r.getDate() + n);
    return r;
  }

  // Find the next shipping day (inclusive of given date)
  function nextShippingDay(d, shippingDays) {
    var current = cloneDate(d);
    for (var i = 0; i < 30; i++) {
      if (isShippingDay(current, shippingDays)) return current;
      current = addDays(current, 1);
    }
    return current;
  }

  // Add N business days to a date (business days = Mon-Fri, non-holiday)
  function addBusinessDays(d, n) {
    var current = cloneDate(d);
    var added = 0;
    while (added < n) {
      current = addDays(current, 1);
      if (isBusinessDay(current)) added++;
    }
    return current;
  }

  // Get current CET/CEST time
  function getNowCET() {
    // Use Intl to get the correct time in Europe/Rome timezone
    try {
      var formatter = new Intl.DateTimeFormat('en-US', {
        timeZone: 'Europe/Rome',
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit',
        hour12: false
      });
      var parts = {};
      formatter.formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
      return new Date(
        parseInt(parts.year), parseInt(parts.month) - 1, parseInt(parts.day),
        parseInt(parts.hour), parseInt(parts.minute), parseInt(parts.second)
      );
    } catch (e) {
      // Fallback: assume CET (UTC+1)
      var now = new Date();
      var utc = now.getTime() + (now.getTimezoneOffset() * 60000);
      return new Date(utc + 3600000);
    }
  }

  /**
   * Calculate estimated delivery dates
   * @param {Object} opts
   * @param {string} opts.type - 'in_stock', 'backordered', 'plant_in_stock', 'plant_backordered'
   * @param {string} opts.locale - 'it', 'fr', 'en'
   * @returns {Object} { shipDate, deliveryMin, deliveryMax, formatted, formattedCompact, formattedShort }
   */
  function calculateEDD(opts) {
    var type = opts.type || 'in_stock';
    var locale = opts.locale || 'it';
    var isEurope = locale !== 'it';

    var now = getNowCET();
    var today = cloneDate(now);
    var hour = now.getHours();
    var deadlinePassed = hour >= 12;

    var shippingDays, deliveryMin, deliveryMax;

    if (isEurope) {
      // Europe: ship only Monday, deliver in 4-5 business days
      shippingDays = [1]; // Monday only
      deliveryMin = 4;
      deliveryMax = 5;
    } else if (type === 'plant_in_stock') {
      // Plants IT: ship Mon-Wed
      shippingDays = [1, 2, 3];
      deliveryMin = 1;
      deliveryMax = 3;
    } else if (type === 'backordered' || type === 'plant_backordered') {
      // Su ordinazione: 10 business days (ship Mon-Fri)
      shippingDays = [1, 2, 3, 4, 5];
      deliveryMin = 10;
      deliveryMax = 10;
    } else {
      // Standard IT: ship Mon-Fri
      shippingDays = [1, 2, 3, 4, 5];
      deliveryMin = 1;
      deliveryMax = 3;
    }

    // Determine ship date
    var shipDate;
    if (isShippingDay(today, shippingDays) && !deadlinePassed) {
      shipDate = today;
    } else {
      shipDate = nextShippingDay(addDays(today, 1), shippingDays);
    }

    // Calculate delivery window
    var minDate = addBusinessDays(shipDate, deliveryMin);
    var maxDate = addBusinessDays(shipDate, deliveryMax);

    return formatResult(shipDate, minDate, maxDate, locale, type, isEurope);
  }

  function formatResult(shipDate, minDate, maxDate, locale, type, isEurope) {
    var weekdays, months, monthsShort;
    if (locale === 'fr') {
      weekdays = WEEKDAYS_FR; months = MONTHS_FR; monthsShort = MONTHS_SHORT_FR;
    } else if (locale === 'en') {
      weekdays = WEEKDAYS_EN; months = MONTHS_EN; monthsShort = MONTHS_SHORT_EN;
    } else {
      weekdays = WEEKDAYS_IT; months = MONTHS_IT; monthsShort = MONTHS_SHORT_IT;
    }

    var minDay = weekdays[minDate.getDay()];
    var maxDay = weekdays[maxDate.getDay()];
    var minDateNum = minDate.getDate();
    var maxDateNum = maxDate.getDate();
    var minMonth = months[minDate.getMonth()];
    var maxMonth = months[maxDate.getMonth()];
    var minMonthShort = monthsShort[minDate.getMonth()];
    var maxMonthShort = monthsShort[maxDate.getMonth()];

    var formatted, formattedCompact, shipNote;

    if (locale === 'it') {
      if (type === 'backordered' || type === 'plant_backordered') {
        formatted = 'Su ordinazione, consegna stimata entro <strong>' + maxDay + ' ' + maxDateNum + ' ' + maxMonth + '</strong>';
        formattedCompact = 'Su ordinazione, entro il ' + maxDateNum + ' ' + maxMonthShort;
      } else {
        var isPlant = type === 'plant_in_stock';
        formatted = 'In magazzino, ordina oggi e ricevi tra <strong>' + minDay + ' ' + minDateNum + '</strong> e <strong>' + maxDay + ' ' + maxDateNum + ' ' + maxMonth + '</strong>';
        formattedCompact = 'Consegna: ' + minDateNum + ' ' + minMonthShort + ' - ' + maxDateNum + ' ' + maxMonthShort;
        if (isPlant) {
          shipNote = 'Le piante le spediamo da Lunedì a Mercoledì';
        }
      }
    } else if (locale === 'fr') {
      if (type === 'backordered' || type === 'plant_backordered') {
        formatted = 'Sur commande, livraison estimée d\'ici le <strong>' + maxDay + ' ' + maxDateNum + ' ' + maxMonth + '</strong>';
        formattedCompact = 'Sur commande, d\'ici le ' + maxDateNum + ' ' + maxMonthShort;
      } else {
        formatted = 'En stock, commandez aujourd\'hui et recevez entre <strong>' + minDay + ' ' + minDateNum + '</strong> et <strong>' + maxDay + ' ' + maxDateNum + ' ' + maxMonth + '</strong>';
        formattedCompact = 'Livraison: ' + minDateNum + ' ' + minMonthShort + ' - ' + maxDateNum + ' ' + maxMonthShort;
      }
      shipNote = 'Nous expédions uniquement le Lundi';
    } else {
      if (type === 'backordered' || type === 'plant_backordered') {
        formatted = 'On order, estimated delivery by <strong>' + maxDay + ' ' + maxDateNum + ' ' + maxMonth + '</strong>';
        formattedCompact = 'On order, by ' + maxDateNum + ' ' + maxMonthShort;
      } else {
        formatted = 'In stock, order today and receive between <strong>' + minDay + ' ' + minDateNum + '</strong> and <strong>' + maxDay + ' ' + maxDateNum + ' ' + maxMonth + '</strong>';
        formattedCompact = 'Delivery: ' + minDateNum + ' ' + minMonthShort + ' - ' + maxDateNum + ' ' + maxMonthShort;
      }
      shipNote = 'We ship on Mondays only';
    }

    return {
      shipDate: shipDate,
      deliveryMin: minDate,
      deliveryMax: maxDate,
      formatted: formatted,
      formattedCompact: formattedCompact,
      formattedPlain: formatted.replace(/<[^>]*>/g, ''),
      shipNote: shipNote || null,
      type: type
    };
  }

  // SVG icon paths (from theme icon.liquid, viewBox 0 0 16 16)
  var ICONS = {
    check_mark: '<path fill="currentColor" fill-rule="evenodd" d="M14.441 3.733a.5.5 0 010 .707l-7.94 7.94a.5.5 0 01-.707 0L2.52 9.105a.5.5 0 11.707-.707l2.922 2.922 7.586-7.587a.5.5 0 01.707 0z" clip-rule="evenodd"/>',
    box: '<path fill="currentColor" d="M14.41 3.37L8.27 1.41a1 1 0 00-.61 0L1.52 3.37a1 1 0 00-.7.95v7.86c0 .41.25.78.63.93l6.14 2.46c.24.1.5.1.75 0l6.14-2.46a1 1 0 00.62-.93V4.32a1 1 0 00-.69-.95zM7.96 2.36l6.05 1.93-2.7.9L5.35 3.2l2.63-.84zm-.46 12.1l-5.68-2.28V5.3L7.5 7.2v7.26zM8 6.3L1.96 4.28l2.58-.82 5.99 2L8 6.3zm6.1 5.89l-5.6 2.24V7.19l5.6-1.87v6.87z"/>',
    leaf: '<path fill="currentColor" d="M14.63.98a1 1 0 00-.78-.3h-.03l-.07.01-.25.03a41.89 41.89 0 00-3.87.52c-1.1.2-2.31.48-3.38.83a7.15 7.15 0 00-2.74 1.48 6.04 6.04 0 00-.36 8.15L1.53 13.3a.5.5 0 00.71.7l1.61-1.6a6.04 6.04 0 008.2-.31 7.15 7.15 0 001.48-2.74c.36-1.07.63-2.27.83-3.39a46.92 46.92 0 00.53-3.86l.02-.26.01-.07v-.02a1 1 0 00-.29-.78zm-1.72.8l.17-.02-4.89 4.9v-4.1c1.76-.41 3.61-.66 4.72-.78zM8.45 7.81h4.5c-.21.8-.45 1.56-.74 2.2H6.24l2.21-2.2zM7.7 2.68v4.46L5.5 9.35V3.43c.64-.3 1.4-.54 2.2-.75zM4.22 4.26c.2-.2.47-.4.78-.57v6.15L3.86 11a5.04 5.04 0 01.36-6.73zm.34 7.44l1.19-1.18h6.22c-.2.35-.4.65-.62.87a5.04 5.04 0 01-6.8.31zm8.5-4.4h-4.1l4.9-4.9-.03.3a41.1 41.1 0 01-.76 4.6z"/>'
  };

  function svgIcon(name, size) {
    return '<svg class="icon icon--' + name + '" width="' + size + '" height="' + size + '" viewBox="0 0 16 16" aria-hidden="true" focusable="false" role="presentation">' + (ICONS[name] || '') + '</svg>';
  }

  /**
   * Render EDD into a target element
   * @param {HTMLElement} el - Target container
   * @param {Object} opts - { type, locale, compact }
   */
  function renderEDD(el, opts) {
    if (!el) return;
    var result = calculateEDD(opts);
    var compact = opts.compact || false;

    var html = '';
    var badgeClass = 'shipping-badge--in-stock';
    var icon = 'check_mark';

    if (result.type === 'backordered' || result.type === 'plant_backordered') {
      badgeClass = 'shipping-badge--backordered';
      icon = 'box';
    }

    var sizeClass = compact ? ' shipping-badge--sm' : '';
    var iconSize = compact ? 16 : 20;
    var text = compact ? result.formattedCompact : result.formatted;

    html += '<div class="shipping-badge ' + badgeClass + sizeClass + '">';
    html += '<span class="shipping-badge__icon">' + svgIcon(icon, iconSize) + '</span>';
    html += '<span class="shipping-badge__text">' + text + '</span>';
    html += '</div>';

    if (result.shipNote && !compact) {
      var noteClass = result.type.indexOf('backorder') !== -1 ? 'shipping-badge--backordered' : 'shipping-badge--info';
      html += '<div class="shipping-badge ' + noteClass + sizeClass + '">';
      html += '<span class="shipping-badge__icon">' + svgIcon('leaf', iconSize) + '</span>';
      html += '<span class="shipping-badge__text"><strong>' + result.shipNote + '</strong></span>';
      html += '</div>';
    }

    el.innerHTML = html;
  }

  /**
   * Initialize all EDD elements on the page
   */
  function initEDD() {
    var elements = document.querySelectorAll('[data-edd]:not([data-edd-rendered])');
    for (var i = 0; i < elements.length; i++) {
      var el = elements[i];
      var type = el.getAttribute('data-edd-type') || 'in_stock';
      var locale = el.getAttribute('data-edd-locale') || 'it';
      var compact = el.hasAttribute('data-edd-compact');
      renderEDD(el, { type: type, locale: locale, compact: compact });
      el.setAttribute('data-edd-rendered', 'true');
    }

    // Update Spedizione properties with calculated dates
    var propInputs = document.querySelectorAll('[data-edd-shipping-prop]');
    for (var j = 0; j < propInputs.length; j++) {
      var input = propInputs[j];
      // Preorder safeguard: keep the ERP preorder message untouched
      if (/preordine|pre-?order|pr[eé]commande/i.test(input.value || '') || document.querySelector('[data-has-preorder-config="true"]')) continue;
      var propType = input.getAttribute('data-edd-type') || 'in_stock';
      var propLocale = input.getAttribute('data-edd-locale') || 'it';
      var result = calculateEDD({ type: propType, locale: propLocale });
      if (result.shipNote) {
        input.value = result.formattedPlain + '. ' + result.shipNote;
      } else {
        input.value = result.formattedPlain;
      }
    }

    // If cart items with shipping info are on the page, update their Spedizione properties
    if (document.querySelector('.cart-item-shipping-info[data-edd-cart-type]')) {
      updateCartShippingProperties();
    }
  }

  // Re-init after Shopify section rendering and cart updates
  function bindSectionEvents() {
    document.addEventListener('shopify:section:load', initEDD);
    // Listen for variant changes (Canopy theme re-renders content via fetch)
    document.addEventListener('on:variant:change', function () {
      setTimeout(initEDD, 100);
    });
    // After add-to-cart, update Spedizione properties on cart items
    document.addEventListener('on:cart:add', function () {
      setTimeout(updateCartShippingProperties, 800);
    });
    document.addEventListener('on:line-item:change', function () {
      setTimeout(updateCartShippingProperties, 800);
    });

    // Observe DOM for dynamically inserted [data-edd] elements (cart drawer, AJAX cart)
    var eddObserver = new MutationObserver(function (mutations) {
      var needsInit = false;
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeType === 1) {
            if (added[j].hasAttribute && added[j].hasAttribute('data-edd')) {
              needsInit = true;
              break;
            }
            if (added[j].querySelector && added[j].querySelector('[data-edd]')) {
              needsInit = true;
              break;
            }
          }
        }
        if (needsInit) break;
      }
      if (needsInit) {
        setTimeout(initEDD, 50);
      }
    });

    eddObserver.observe(document.body, { childList: true, subtree: true });
  }

  /**
   * Update Spedizione properties on all cart items via Shopify Cart API.
   * This ensures dates are always fresh, even if items were added days ago.
   */
  var cartUpdatePending = false;
  function updateCartShippingProperties() {
    if (cartUpdatePending) return;
    cartUpdatePending = true;

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items || cart.items.length === 0) {
          cartUpdatePending = false;
          return;
        }

        // Collect items that need a property update
        var toUpdate = [];

        cart.items.forEach(function (item) {
          // Preorder safeguard: never overwrite a preorder shipping property
          var __prop = (item.properties && item.properties.Spedizione) || '';
          var __pre = document.querySelector('.cart-item-shipping-info[data-item-key="' + item.key + '"] .shipping-badge--preorder');
          if (__pre || /preordine|pre-?order|pr[eé]commande/i.test(__prop)) return;

          // Try to find EDD info from DOM (cart drawer/page), otherwise infer from product tags
          var el = document.querySelector('.cart-item-shipping-info[data-item-key="' + item.key + '"]');
          var eddType, eddLocale;

          if (el) {
            eddType = el.getAttribute('data-edd-cart-type');
            eddLocale = el.getAttribute('data-edd-cart-locale') || 'it';
          } else {
            // Fallback: use existing property to determine type
            var currentProp = (item.properties && item.properties['Spedizione']) || '';
            if (!currentProp) return;
            eddLocale = 'it';
            if (currentProp.indexOf('Su ordinazione') !== -1 || currentProp.indexOf('Sur commande') !== -1 || currentProp.indexOf('On order') !== -1) {
              eddType = 'backordered';
              if (currentProp.indexOf('Sur commande') !== -1) eddLocale = 'fr';
              if (currentProp.indexOf('On order') !== -1) eddLocale = 'en';
            } else {
              eddType = 'in_stock';
              if (currentProp.indexOf('En stock') !== -1) eddLocale = 'fr';
              if (currentProp.indexOf('In stock') !== -1) eddLocale = 'en';
            }
          }

          if (!eddType) return;

          var result = calculateEDD({ type: eddType, locale: eddLocale });
          var newValue = result.formattedPlain;
          if (result.shipNote) newValue += '. ' + result.shipNote;

          var currentValue = (item.properties && item.properties['Spedizione']) || '';
          if (currentValue !== newValue) {
            var props = Object.assign({}, item.properties || {});
            props['Spedizione'] = newValue;
            toUpdate.push({ id: item.key, quantity: item.quantity, properties: props });
          }
        });

        if (toUpdate.length === 0) {
          cartUpdatePending = false;
          return;
        }

        // Update one at a time via /cart/change.js (Shopify doesn't batch property changes)
        function updateNext(i) {
          if (i >= toUpdate.length) {
            cartUpdatePending = false;
            return;
          }
          fetch('/cart/change.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(toUpdate[i])
          }).then(function () {
            updateNext(i + 1);
          }).catch(function () {
            updateNext(i + 1);
          });
        }
        updateNext(0);
      })
      .catch(function () { cartUpdatePending = false; });
  }

  // Public API
  window.MillstoreEDD = {
    calculate: calculateEDD,
    render: renderEDD,
    init: initEDD,
    updateCartProperties: updateCartShippingProperties
  };

  // Auto-init on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initEDD();
      bindSectionEvents();
    });
  } else {
    initEDD();
    bindSectionEvents();
  }
})();
